const _apiPrefix: string = process.env.REACT_APP_API_PREFIX ?? "/api/v1";
const _apiHostUrl: string =
	process.env.REACT_APP_API_HOST_URL ?? "http://127.0.0.1:5001";

export const serviceConfig = {
	apiHost: _apiHostUrl,
	apiUrl: `${_apiHostUrl}${_apiPrefix}`,
	useMockApi: process.env.REACT_APP_USE_MOCK_API
		? parseInt(process.env.REACT_APP_USE_MOCK_API)
		: 1,
	ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY ? process.env.REACT_APP_ENCRYPTION_KEY : "",
	ENCRYPTION_IV: process.env.REACT_APP_ENCRYPTION_IV ? process.env.REACT_APP_ENCRYPTION_IV : "",

	routes: {
		all_sliders:
			process.env.REACT_APP_API_ALL_SLIDERS_ROUTE ?? "/tbl-dk-sliders/",
	},
};
